<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>プラスの氣 TOP</template>
    </PageHeader>

    <div class="text-center px-3">
      <SectionTitle title="ランキング" />
      <v-col cols="12" class="text-right py-0">
        <Button
          @click="
            $router.push({
              name: 'EncouragementsRanking',
            })
          "
          color="info"
          >ランキングをもっとみる</Button
        >
      </v-col>
      <v-row class="mb-5">
        <v-col cols="12" md="6">
          <RecieveRanking
            :pageKind="topPageName"
            :biginDay="biginMonthDay"
            :endDay="endMonthDay"
          />
        </v-col>
        <v-col cols="12" md="6">
          <SendRanking
            :pageKind="topPageName"
            :biginDay="biginMonthDay"
            :endDay="endMonthDay"
          />
        </v-col>
      </v-row>

      <SectionTitle title="プラスの氣一覧" />
      <v-row>
        <DatePicker v-model="searchForm.dateFrom" label="表示開始日" />
        <DatePicker v-model="searchForm.dateTo" label="表示終了日" />
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <FormInputComponent
            label="氏名"
            v-model="searchKey"
            :length="10"
            :counter="10"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-radio-group v-model="searchKind" row>
            <v-radio label="全て" value="9"></v-radio>
            <v-radio label="受信のみ" value="1"></v-radio>
            <v-radio label="送信のみ" value="0"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="6" sm="6" md="4">
          <Button @click="get_comment(true)" color="primary" v-if="isNotProcess"
            >絞り込み</Button
          >
        </v-col>
      </v-row>
      <v-row
        ><v-col class="pt-0 pb-0 pl-0 pr-0 mt-n5 mb-n2"
          ><Loader :loading="loading" /></v-col
      ></v-row>

      <v-card-subtitle class="text-left"
        >プラスの氣は「{{ searchNum }}」件です。</v-card-subtitle
      >

      <v-row class="text-center">
        <v-col
          cols="12"
          md="3"
          v-for="(item, index) in items"
          :key="index"
          @click="onClickOpen(item)"
        >
          <Card :item="item" :loading="loading" />
        </v-col>
      </v-row>

      <EmptyState
        v-if="!items.length"
        title="プラスの氣は見つかりませんでした"
        imagePath="empty-state-encouragements.svg"
        size="250"
      >
        <p>
          表示期間を変更して絞り込みを行ってください。<br />
          まだプラスの氣が存在しない場合、あなたが記念すべき最初のプラスの氣を送信しましょう。<br />
          プラスの氣の作成はこちらから行うことができます。
        </p>
        <Button
          @click="$router.push({ name: 'EncouragementsSend' })"
          color="info"
          >プラスの氣を送る</Button
        >
      </EmptyState>
    </div>

    <Loader :loading="loading" />

    <detail ref="detail" @detail="get_comment(false)"></detail>

    <DialogMessage ref="dialog" />
  </v-container>
</template>

<script>
import axios from 'axios';
import {
  getCurrentDay,
  getFromDay,
  format,
  getBiginMonthDay,
  getEndMonthDay,
} from '@/utils/day.js';
import { generateMessage } from '@/utils/common.js';
import config from '../../../const.js';
import message from '../../../message.js';
import Card from '@/components/Common/Card.vue';
import detail from '@/components/pages/Encouragements/DetailDialog.vue';
import RecieveRanking from '@/components/pages/Encouragements/RecieveRanking.vue';
import SendRanking from '@/components/pages/Encouragements/SendRanking.vue';
import { getSessionStorageItem, makeDateTimeStr } from '../../../common.js';

export default {
  components: {
    Card,
    detail,
    RecieveRanking,
    SendRanking,
  },

  data() {
    return {
      // Breadcrumbs
      crumbs: [
        {
          name: 'プラスの氣 TOP',
          route: 'EncouragementsTop',
        },
      ],

      showContent: false,
      loading: false,
      searchKind: '9', // 「全て」を初期選択
      searchForm: {
        dateFrom: '',
        dateTo: '',
      },
      searchKey: '',
      userInfo: {},
      items: [],
      topPageName: config.PURASUNOKI_TOP_PAGE,
      biginMonthDay: getBiginMonthDay(),
      endMonthDay: getEndMonthDay(),
      searchNum: 0,

      // 絞り込みボタン表示・非表示制御
      isNotProcess: true,
    };
  },

  created() {
    this.initializeSearchForm();

    this.userInfo = getSessionStorageItem();
  },
  mounted() {
    this.get_comment(true);
  },

  methods: {
    onClickOpen(item) {
      // システム管理者の権限チェック
      let userInfo = getSessionStorageItem();
      if (userInfo.USER_RANK == config.USER_RANK_SYSOP) {
        let infoStr = 'システム管理者はプラスの氣を操作できません。';
        this.$refs.dialog.open('info', infoStr);
        return;
      }
      this.$refs.detail.open(item);
    },
    get_comment(search_flg) {
      this.items = [];

      if (this.userInfo.SESSION_ID === null) {
        return this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
      }
      // 日付From Toチェック
      if (
        makeDateTimeStr('S', this.searchForm.dateFrom) >
        makeDateTimeStr('E', this.searchForm.dateTo)
      ) {
        this.$refs.dialog.open('warning', message.MSG_WARN_DATE_ERROR);
        return this.initializeSearchForm();
      }

      // 氏名の設定
      if (this.searchKey == null || !this.searchKey.trim()) {
        this.searchKey = config.EMPTY_STRING;
      }

      // 絞り込みボタン非表示
      this.isNotProcess = false;
      // ローディング開始
      this.loading = true;
      // 検索件数初期化
      this.searchNum = 0;

      //----- プラスの氣件数チェック
      axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/CommentSearchNum/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY +
            '/' +
            makeDateTimeStr('S', this.searchForm.dateFrom) +
            '/' +
            makeDateTimeStr('E', this.searchForm.dateTo)
        )
        .then((response) => {
          // プラスの氣データ件数取得
          if (response.data.SEARCH_NUM > config.PURASUNOKI_MAX_NUM) {
            // 絞り込み結果が500件を超えた場合
            let infoStr = message.MSG_WARN_RANKING_MAX_ERROR;
            let infoStrReplace = infoStr.replace(
              /a/g,
              config.PURASUNOKI_MAX_NUM
            );
            this.$refs.dialog.open('info', infoStrReplace);
            return;
          } else {
            // 絞り込み結果が500件以下の場合、プラスの氣を取得
            //----- プラスの氣取得リクエストGET
            axios
              .get(
                config.CONNECT_URL +
                  '/Encouragements/comments/' +
                  this.userInfo.SESSION_ID +
                  '/' +
                  this.userInfo.USER_ID +
                  '/' +
                  this.userInfo.ORGANIZATION_KEY +
                  '/' +
                  makeDateTimeStr('S', this.searchForm.dateFrom) +
                  '/' +
                  makeDateTimeStr('E', this.searchForm.dateTo) +
                  '/' +
                  this.searchKind +
                  '/' +
                  this.searchKey
              )
              .then((response) => {
                // プラスの氣データ取得
                this.items = response.data;

                // 絞り込み結果が500件を超えた場合
                if (this.items.length > config.PURASUNOKI_MAX_NUM) {
                  // 絞り込み結果が500件を超えた場合
                  let infoStr = message.MSG_WARN_RANKING_MAX_ERROR;
                  let infoStrReplace = infoStr.replace(
                    /a/g,
                    config.PURASUNOKI_MAX_NUM
                  );
                  this.$refs.dialog.open('info', infoStrReplace);
                  return;
                }

                // アバター接続URL作成
                for (var i = 0; i < this.items.length; i++) {
                  this.items[i].SEND_USER_AVATER =
                    config.S3_END_POINT +
                    config.AVATER_DIRECTORY +
                    this.items[i].SEND_USER_AVATER +
                    '?' +
                    format('YYYYMMDDHHmmss');
                  this.items[i].TO_USER_AVATER =
                    config.S3_END_POINT +
                    config.AVATER_DIRECTORY +
                    this.items[i].TO_USER_AVATER +
                    '?' +
                    format('YYYYMMDDHHmmss');
                }

                // 検索文字調整
                if (this.searchKey == config.EMPTY_STRING) {
                  this.searchKey = '';
                }

                // 検索結果が最大件数のメッセージ
                if (search_flg) {
                  if (this.items.length >= config.PURASUNOKI_MYSELF_MAX_NUM) {
                    let infoStr = message.MSG_INFO_PURASUNOKI_LIST_MAX;
                    let infoStrReplace = infoStr.replace(
                      /a/g,
                      config.PURASUNOKI_MYSELF_MAX_NUM
                    );
                    this.$refs.dialog.open('info', infoStrReplace);
                  }
                }

                // 検索件数の表示
                this.searchNum = this.items.length;

                this.loading = false;
              })
              .catch((error) => {
                this.loading = false;

                if (error.response.status == 404) {
                  return this.$refs.dialog.open(
                    'error',
                    generateMessage(message.NOT_FOUND, ['プラスの氣'])
                  );
                }
                if (error.response.status == 400) {
                  return this.$refs.dialog.open(
                    'error',
                    message.MSG_ERROR_SESSION + error
                  );
                } else {
                  return this.$refs.dialog.open(
                    'error',
                    message.MSG_ERROR_SYTEM + error
                  );
                }
              });
          }
        })
        .catch((error) => {
          if (error.response.status == 404) {
            return this.$refs.dialog.open(
              'error',
              generateMessage(message.NOT_FOUND, ['プラスの氣'])
            );
          }
          if (error.response.status == 400) {
            return this.$refs.dialog.open(
              'error',
              message.MSG_ERROR_SESSION + error
            );
          } else {
            return this.$refs.dialog.open(
              'error',
              message.MSG_ERROR_SYTEM + error
            );
          }
        })
        .finally(() => {
          // 検索文字調整
          if (this.searchKey == config.EMPTY_STRING) {
            this.searchKey = '';
          }
          // ローディング画像表示
          this.loading = false;
          // 絞り込みボタン表示
          this.isNotProcess = true;
        });
    },

    initializeSearchForm() {
      this.searchForm.dateFrom = getFromDay(1);
      this.searchForm.dateTo = getCurrentDay();
    },
  },
};
</script>
